import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const Wrapper = styled.div`
  margin: ${spacing.space8} 0 ${spacing.space24} 0;
`;
